import { getWidthBlock } from '../getWidthBlock'

export const styles = () => ({
  container: {
    height: 140,
    borderRadius: 10,
    overflow: 'hidden',
  },
})

export const templateVideoStyle = (device, received) => ({
  width: getWidthBlock(device),
  marginRight: received ? '' : '10px',
})
